<template>
  <div>
    <toolbar />
    <mainView />
  </div>
</template>

<script>
import toolbar from "./../../components/structure/toolbar.vue";
import mainView from "./mainView.vue";

export default {
  components: {
    toolbar,
    mainView
  }
};
</script>